import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { booksellersManageService } from '../api/booksellersManageService';
import type { BooksellerFilterState, ManageBooksellersListResult } from '../types/manageBooksellers';

export function useBooksellerListQuery(filters: BooksellerFilterState) {
  return useQuery<ManageBooksellersListResult>({
    queryKey: ['manage-booksellers', filters],
    queryFn: () => booksellersManageService.list(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
